module.exports = __webpack_public_path__ + "static/media/OpenSans-SemiBold.e1c83f94.ttf";